const state =
    {
        assistantModuleList: {
            cul: {
                value: 5,
                module: "cul.quantity"
            },
            pos: {
                value: 0,
                module: "pos.quantity"
            },
            webstore: {
                value: 0,
                module: "webstore.client"
            },
            hosting: {
                value: 92,
                module: "hosting.type"
            },
            ebics: {
                value: 0,
                module: "order.payment.bank.quantity"
            },
            warehouse: {
                value: 3,
                module: "stock.warehouse.sales.quantity"
            },
            feeByTotals: {
                value: 0,
                module: "accounting.fee.by.totals"
            },
            feeByOrders: {
                value: 0,
                module: "accounting.fee.by.orders"
            }
        },
        showPlentyBiPage: true,
        biPlans: [],
        selectedBiPlanItemId: null,
        biPlanModalData: null,
        contractsToSkip: ["startzero", "startadvanced", "partner"],
        pid: 0,
        systemContractType: "",
        contractWhitelist: [],
        contractModuleList: {},
        systemModuleList: {},
        contractList: {},
        preparedContractList: [],
        upgradeNotAllowed: {},
        selectedContractType: "",
        calcContractType: "",
        contract: {},
        selectedHostingId: 0,
        additionalCosts: {},
        addItemsToContract: "",
        updateItemsToContract: "",
        refContractType: "",
        referrer: "",
        referrerMap: {
            i: "ionos",
            // eslint-disable-next-line
            s: "strato",
            // eslint-disable-next-line
            a: "arsys",
            // eslint-disable-next-line
            f: "fasthosts",
            // eslint-disable-next-line
            p: "piensa"
        },
        showWarning: false,
        orderPackages: null
    };

const mutations =
    {
        setShowPlentyBiPage(state, payload)
        {
            state.showPlentyBiPage = payload;
        },
        setContractsToSkip(state, payload)
        {
            state.contractsToSkip = payload;
        },

        setBiPlans(state, payload)
        {
            state.biPlans = Object.keys(payload).filter(key =>
            {
                return !!payload[key].data.contractAvailability;
            }).map(key =>
            {
                return payload[key];
            });
        },

        setBiPlanModalData(state, payload)
        {
            state.biPlanModalData = payload;
        },

        setSelectedBiPlanItemId(state, payload)
        {
            state.selectedBiPlanItemId = payload;
        },

        enableAllContracts(state)
        {
            for (const contractTypeKey in state.contractModuleList)
            {
                this.commit("setUpgradeNotAllowed", {contractTypeKey, notAllowed: false});
            }
        },

        setContractWhitelist(state, payload)
        {
            state.contractWhitelist = payload;
        },

        setSystemContractType(state, payload)
        {
            state.systemContractType = payload;
        },

        setRefContractType(state, payload)
        {
            state.refContractType = payload;
        },

        setPid(state, payload)
        {
            state.pid = parseInt(payload);
        },

        setReferrer(state, payload)
        {
            state.referrer = state.referrerMap[payload] || "";
        },

        setAdditionalCosts(state, payload)
        {
            state.additionalCosts = payload;
        },

        setAssistantModuleValue(state, payload)
        {
            state.assistantModuleList[payload.module].value = parseInt(payload.value);
        },

        setModulesList(state, payload)
        {
            for (const skipContract of state.contractsToSkip)
            {
                if (payload[skipContract] !== null)
                {
                    delete payload[skipContract];
                }
            }
            if (payload._currentContract !== null)
            {
                if (typeof payload._currentContract !== "undefined")
                {
                    payload._currentContract["webstore.client"].value += 1;
                }
                this.commit("setSystemModuleList", payload._currentContract);
                delete payload._currentContract;
            }

            this.commit("setContractModuleList", payload);
        },

        setSystemModuleList(state, payload)
        {
            state.systemModuleList = payload;
        },

        setContractModuleList(state, payload)
        {
            state.contractModuleList = payload;
        },

        setSelectedContractType(state, payload)
        {
            state.selectedContractType = payload;
        },

        setCalcContractType(state, payload)
        {
            state.calcContractType = payload;
            state.selectedContractType = payload;
        },

        setSelectedHostingId(state, payload)
        {
            state.selectedHostingId = payload;
        },

        setContractList(state, payload)
        {
            state.contractList = payload;
        },

        setContract(state, payload)
        {
            state.contract = payload;
        },

        setUpgradeNotAllowed(state, payload)
        {
            if (payload.contractTypeKey)
            {
                state.upgradeNotAllowed[payload.contractTypeKey] = payload.notAllowed;
            }
        },

        selectContract(state, payload)
        {
            for (const module of ["feeByTotals", "feeByOrders"])
            {
                state.assistantModuleList[module].value = 0;
            }
            if (!state.contractList[state.selectedContractType][payload])
            {
                for (const key in state.contractList)
                {
                    if (state.contractList.hasOwnProperty(key) && state.contractList[key][payload])
                    {
                        state.selectedContractType = key;
                        this.dispatch("capModuleValue");
                        break;
                    }
                }
            }
        },

        prepareContractList(state, payload)
        {
            for (const skipContract of state.contractsToSkip)
            {
                if (payload[skipContract] !== null)
                {
                    delete payload[skipContract];
                }
            }
            state.contractList = payload;
            state.preparedContractList = [];

            for (const i in state.contractList)
            {
                const contract = state.contractList[i];
                const firstKey = Object.keys(contract)[0];

                contract[firstKey].data.properties.forEach(property =>
                {
                    if (property.property.names.name === "MinimumContractTerm")
                    {
                        contract[firstKey].minimumContractTerm = property.valueInt;
                    }
                });

                if (contract.totals)
                {
                    contract[firstKey].data.totals = contract.totals;
                }
                if (contract.orders)
                {
                    contract[firstKey].data.orders = contract.orders;
                }
                contract[firstKey].data.contractType = i;

                state.preparedContractList.push(contract[firstKey]);
            }
        },

        getSelectedModules(state)
        {
            state.addItemsToContract = "";
            state.updateItemsToContract = "";

            for (const assistantModuleKey in state.assistantModuleList)
            {
                const assistantModule = state.assistantModuleList[assistantModuleKey];

                if (assistantModule.module.includes("accounting.fee.by") &&
                    state.selectedContractType !== "proflex")
                {
                    continue;
                }

                const module = state.contractModuleList[state.selectedContractType][assistantModule.module];

                if (assistantModule.module !== "hosting.type")
                {
                    let excluded = module.included ? (assistantModule.value - module.included) : assistantModule.value;

                    if (assistantModule.module === "webstore.client" && !module.included)
                    {
                        excluded -= 1;
                    }

                    excluded = Math.max(0, excluded);

                    if (excluded > 0)
                    {
                        state.addItemsToContract += "&modules[" + module.itemId + "]=" + excluded;
                    }

                    if (state.systemModuleList && Object.keys(state.systemModuleList).length > 0)
                    {
                        if (state.systemModuleList[assistantModule.module].value !== null &&
                            assistantModule.value > 0 &&
                            (assistantModule.value - state.systemModuleList[assistantModule.module].value) > 0)
                        {
                            state.updateItemsToContract += "&modules[" + module.itemId + "]=" +
                                (assistantModule.value - state.systemModuleList[assistantModule.module].value);
                        }
                        else if (excluded > 0)
                        {
                            state.updateItemsToContract += "&modules[" + module.itemId + "]=" + excluded;
                        }
                    }
                }
            }
        },

        showWarning()
        {
            state.showWarning = true;
        },

        setClassicOrderPackages(state, orderPackages)
        {
            state.orderPackages = orderPackages;
        }
    };

const actions =
    {
        capModuleValue({state, commit})
        {
            for (const assistantModuleKey in state.assistantModuleList)
            {
                const assistantModule = state.assistantModuleList[assistantModuleKey];
                const contractModule = state.contractModuleList[state.selectedContractType][assistantModule.module];

                let itemMax = 0;

                if (contractModule)
                {
                    itemMax += contractModule.included || 0;
                    itemMax += contractModule.max || 0;

                    if (assistantModule.module === "webstore.client" && !contractModule.included)
                    {
                        itemMax += 1;
                    }

                    if (assistantModule.module !== "hosting.type" &&
                        assistantModule.module !== "accounting.fee.by.totals" &&
                        assistantModule.module !== "accounting.fee.by.orders" &&
                        assistantModule.value > itemMax)
                    {
                        commit("setAssistantModuleValue", {module: assistantModuleKey, value: itemMax});
                    }
                }
            }
        },

        getContractModuleList({state, commit})
        {
            let params = "";

            if (state.pid > 0 &&
                Object.keys(this.state.contact.contact).length > 0)
            {
                params += "?plentyId=" + state.pid + "&contactId=" + this.state.contact.contact.id;
            }

            return new Promise((resolve, reject) =>
            {
                const xHttp = new XMLHttpRequest();

                xHttp.onreadystatechange = function()
                {
                    if (this.readyState === 4 && this.status === 200)
                    {
                        commit("setModulesList", JSON.parse(this.responseText));
                        resolve();
                    }
                    else if (this.readyState === 4 && this.status > 400)
                    {
                        commit("showWarning");
                        reject();
                    }
                };

                xHttp.open("GET", "/rest/system/accounting/configurator_modules" + params, true);
                xHttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                xHttp.send();
            });
        },

        getContractList({commit, state})
        {
            return new Promise(resolve =>
            {
                const xHttp = new XMLHttpRequest();

                xHttp.onreadystatechange = function()
                {
                    if (this.readyState === 4 && this.status === 200)
                    {
                        commit("prepareContractList", JSON.parse(this.responseText));
                        resolve();
                    }
                };

                const params = "?modules[" + state.selectedHostingId + "]=1";

                xHttp.open("GET", "/rest/system/accounting/contract/items" + params, true);

                xHttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                xHttp.send();
            });
        },

        getContract({commit, state, rootState})
        {
            if (state.calcContractType === state.selectedContractType)
            {
                commit("getSelectedModules");
            }

            return new Promise(resolve =>
            {
                const xHttp = new XMLHttpRequest();

                xHttp.onreadystatechange = function()
                {
                    if (this.readyState === 4 && this.status === 200)
                    {
                        commit("setContract", JSON.parse(this.responseText));
                        resolve();
                    }
                };

                let params = "?contractType=" + state.selectedContractType +
                    "&modules[" + state.selectedHostingId + "]=1" + state.addItemsToContract;

                if (rootState.contact.billingAddressData.countryId)
                {
                    params += "&countryId=" + rootState.contact.billingAddressData.countryId;
                }

                if (state.selectedBiPlanItemId)
                {
                    params += "&modules[" + state.selectedBiPlanItemId + "]=1";
                }

                xHttp.open("GET", "/rest/system/accounting/contract/overview" + params, true);
                xHttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                xHttp.send();
            });
        },

        getContractUpdate({commit, state})
        {
            commit("getSelectedModules");

            return new Promise(resolve =>
            {
                const xHttp = new XMLHttpRequest();

                xHttp.onreadystatechange = function()
                {
                    if (this.readyState === 4 && this.status === 200)
                    {
                        commit("setContract", JSON.parse(this.responseText));
                        resolve();
                    }
                };

                let params = "?contractType=" + state.selectedContractType + state.addItemsToContract;

                if (state.selectedBiPlanItemId)
                {
                    params += "&modules[" + state.selectedBiPlanItemId + "]=1";
                }

                xHttp.open("GET", "/rest/system/accounting/contract/overview" + params, true);
                xHttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                xHttp.send();
            });
        },

        orderSystem({commit, state}, payload)
        {
            if (state.calcContractType === state.selectedContractType)
            {
                commit("getSelectedModules");
            }

            return new Promise(resolve =>
            {
                const xHttp = new XMLHttpRequest();

                xHttp.onreadystatechange = function()
                {
                    if (this.readyState === 4 && this.status === 200)
                    {
                        resolve();
                    }
                };

                let params = "?contractType=" + state.selectedContractType + "&referrer=" + state.referrer +
                    "&modules[" + state.selectedHostingId + "]=1" + state.addItemsToContract;

                if (state.selectedBiPlanItemId && state.showPlentyBiPage)
                {
                    params += "&modules[" + state.selectedBiPlanItemId + "]=1";
                }

                xHttp.open("PUT", "/rest/system/accounting/contract/" + payload + params, true);
                xHttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                xHttp.send();
            });
        },

        updateSystem({commit, state}, payload)
        {
            commit("getSelectedModules");

            return new Promise(resolve =>
            {
                const xHttp = new XMLHttpRequest();

                xHttp.onreadystatechange = function()
                {
                    if (this.readyState === 4 && this.status === 200)
                    {
                        resolve();
                    }
                };

                let params = "";

                if (state.selectedBiPlanItemId)
                {
                    params = "&modules[" + state.selectedBiPlanItemId + "]=1";
                }

                xHttp.open("POST", "/rest/system/accounting/contract/" + payload + "/" + state.pid, true);
                xHttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                xHttp.send("contractType=" + state.selectedContractType + state.addItemsToContract + params);
            });
        },

        fetchBiPlans({commit})
        {

            const url = "/rest/system/accounting/contract/module/items/bi.plan";

            return new Promise(resolve =>
            {
                const xHttp = new XMLHttpRequest();

                xHttp.onreadystatechange = function()
                {
                    if (this.readyState === 4 && this.status === 200)
                    {
                        commit("setBiPlans", JSON.parse(this.responseText));
                        resolve();
                    }
                };

                xHttp.open("GET", url, true);
                xHttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                xHttp.send();
            });
        },

        fetchClassicOrderPackages({commit})
        {
            const url = "/rest/system/accounting/contract/items/proclassic?moduleName=order.quantity";

            return new Promise(resolve =>
            {
                const xHttp = new XMLHttpRequest();

                xHttp.onreadystatechange = function()
                {
                    if (this.readyState === 4 && this.status === 200)
                    {
                        commit("setClassicOrderPackages", JSON.parse(this.responseText));
                        resolve();
                    }
                };

                xHttp.open("GET", url, true);
                xHttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                xHttp.send();
            });
        }
    };

const getters =
    {
        getSelectedContractId: state =>
        {
            if (state.contractList && Object.keys(state.contractList).length > 0)
            {
                return Object.keys(state.contractList[state.calcContractType])[0];
            }
            return 0;
        },

        isFlexFeeItem: state => moduleItemId =>
        {
            const modulesToSkip = [
                state.assistantModuleList.feeByTotals.module,
                state.assistantModuleList.feeByOrders.module
            ];

            for (const contractModuleKey in state.contractModuleList)
            {
                for (const moduleKey of modulesToSkip)
                {
                    const module = state.contractModuleList[contractModuleKey][moduleKey];

                    if (module && Number(module.itemId) === Number(moduleItemId))
                    {
                        return true;
                    }
                }

            }
            return false;

        },

        isModuleItem: state => module =>
        {
            if (module.data.variationProperties)
            {
                for (const property of module.data.variationProperties)
                {
                    if (property.property.names.name === "additionalCosts")
                    {
                        return false;
                    }
                }
            }
            return true;
        },

        getInclusiveCount: state => module =>
        {
            if (module.data.variationProperties)
            {
                for (const property of module.data.variationProperties)
                {
                    if (property.property.names.name === "inclusive")
                    {
                        return property.values.value;
                    }
                }
            }
            return 0;
        },

        isAdditionalItem: state => module =>
        {
            if (module.data.variationProperties)
            {
                for (const property of module.data.variationProperties)
                {
                    const names = property.property.names;

                    if (Array.isArray(names))
                    {
                        for (const nameObj of names)
                        {
                            if (nameObj.name === "additionalCosts")
                            {
                                return true;
                            }
                        }
                    }
                    else if (property.property.names.name === "additionalCosts")
                    {
                        return true;
                    }
                }
            }
            return false;
        },

        getPreparedContractByType: state => contractType =>
        {
            return state.preparedContractList.find(contract => contract.data.contractType === contractType);
        },

        getActiveBiPlan: state =>
        {
            return state.pid > 0 && state.systemModuleList["bi.plan"].value || null;
        }

    };

export default {
    state,
    mutations,
    getters,
    actions
};
